<template>
	<button :class="computedClass" :type="type" @click="$emit('click')">{{ label }}</button>
</template>
<script>
export default {
	name: 'BaseButton',
	props: {
		label: {
			type: String,
			required: true,
		},
		classes: {
			type: Array,
			required: false,
		},
		size: {
			type: String,
			default: 'md',
		},
		type: {
			type: String,
			default: 'button',
		},
	},
	computed: {
		computedClass() {
			return [`button button--${this.size}`, ...this.classes];
		},
	},
};
</script>
<style lang="scss" scoped>
@import './BaseButton.scss';
</style>
